import { forwardRef } from 'react';
import { PrimaryInputProps } from './types';

const PrimaryInput = forwardRef<HTMLInputElement, PrimaryInputProps>((props, ref) => {
	return (
		<div className={'pop-relative pop-w-full'}>
			<input
				type={props.type}
				placeholder={props.placeholder}
				className={`pop-input pop-bg-white pop-text-popsizePrimary90 pop-my-2 pop-border-1 pop-border-popsizeSecondary90 ${props.className ? props.className : ''} focus:pop-border-popsizeSecondary90 focus:pop-outline-none focus:pop-border-1`}
				value={props.value}
				onChange={props.onChange}
				maxLength={props.maxLength}
				ref={ref}
			/>
			{props.icon && props.icon}
		</div>
	);
});

export default PrimaryInput;
